import { useQuery } from "@tanstack/react-query";
import { getPackage } from "../../api/apiPackages";

const useGetPackage = (id) => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["package", id],
        queryFn: () => getPackage(id),
        enabled: !!id,
    });

    return {
        package: data?.data || null,
        error,
        isLoading,
    };
};

export default useGetPackage;
